import { useSelector } from "react-redux";
import { RootState } from "services/redux/store";
import { Button, customToaster } from "ui";
import {
    CustomComponentProps,
    GeneralModalProps
} from "utils/types/generalTypes";

export type ConfirmClosePostProps = CustomComponentProps &
    GeneralModalProps & {
        closePostModal: React.Dispatch<React.SetStateAction<boolean>>;
    };

const ConfirmClosePost = ({
    open,
    setOpen,
    closePostModal,
    className,
    style
}: ConfirmClosePostProps) => {
    const { mode } = useSelector((state: RootState) => state.site);

    const handleClose = () => {
        setOpen(false);
        closePostModal(false);
    };
    const handleCloseNotify = () => {
        customToaster("info", "Your Draft Was Saved!", mode);
        handleClose();
    };
    return (
        <div
            className={`incdident-rules-modal modal share-modal is-xsmall has-light-bg ${open ? "is-active" : ""} ${className}`}
            style={style}
        >
            <div
                className="modal-background"
                onClick={() => setOpen(false)}
            ></div>
            <div className="modal-content">
                <div className="card">
                    <div className="card-heading flex-a-start">
                        <div>
                            <h3 className="fw-500"> Save post? </h3>
                        </div>

                        {/* <!-- Close X button --> */}
                        {/* <div className="close-wrap">
                            <span
                                className="close-modal"
                                onClick={() => setOpen(false)}
                            >
                                <SVG
                                    svg="x"
                                    size={16}
                                    className="light-grey-svg"
                                />
                            </span>
                        </div> */}
                    </div>

                    <div className="card-body">
                        <div className="rules-desc momeento-p fw-500 text-center">
                            You can save this to send later from your drafts.
                        </div>
                        <div className="d-flex w-full flex-col flex-j-center flex-a-center gap-5">
                            <Button
                                text="Save"
                                className="close-modal w-full fw-500 "
                                rounded
                                handleClick={handleCloseNotify}
                            />
                            <Button
                                text="Discard"
                                className="close-modal w-full fw-500"
                                rounded
                                type="is-reversed-phantom"
                                handleClick={handleClose}
                                style={{ border: "1px solid #1bace2" }}
                            />
                        </div>
                    </div>

                    {/* <div className="card-footer d-flex flex-j-end">
                        <div className="button-wrap">
                            <Button
                                text="close"
                                className="close-modal"
                                handleClick={() => setOpen(false)}
                            />
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default ConfirmClosePost;
